import { createSlice } from '@reduxjs/toolkit';
import { createThunkHttp } from '../../services/helpers/thunk';

import {
  httpGetAmenities,
} from '../../services/http';

export const selectAmenities = (state) => state.amenities.amenities;
export const selectAmenitiesLoading = (state) => state.amenities.isLoading;

// Thunks
export const getAmenities = createThunkHttp(
  'amenities/getAmenities',
  httpGetAmenities,
);

export const amenitiesSlice = createSlice({
  name: 'amenities',
  initialState: {
    amenities: [],
    isLoading: false,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAmenities.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(getAmenities.fulfilled, (state, action) => ({
        ...state,
        isLoading: false,
        amenities: action.payload,
      }))
      .addCase(getAmenities.rejected, (state) => ({
        ...state,
        isLoading: false,
      }));
  },
});

export default amenitiesSlice.reducer;
